import { Receipt, ArrowRight } from '@phosphor-icons/react';

export const hasDeliverySignature = doc => doc.handtekening === true || (typeof doc.handtekening === 'string' && !!doc.handtekening.trim());

export const isSignedUninvoicedDelivery = doc => {
  return doc.type === 'leverbon' && hasDeliverySignature(doc) && !doc.gefactureerd && !doc.factuur_id
    && !['geannuleerd', 'geblokkeerd', 'afgewezen', 'verwijderd'].includes((doc.status || '').toLowerCase());
};

export const SignedDeliveryInvoice = ({ doc, busy, onCreate }) => <button
  type="button" className="btn btn-primary delivery-invoice-bar" disabled={busy} aria-busy={busy}
  onClick={onCreate} title={`Maak een factuur van de ondertekende leverbon ${doc.id}`}
  data-testid={`signed-invoice-bar-${doc.id}`}>
  <Receipt size={14} weight="bold" aria-hidden="true" />
  <span data-testid={`signed-invoice-label-${doc.id}`}>{busy ? 'Aanmaken…' : 'Maak factuur'}</span>
  <ArrowRight size={13} aria-hidden="true" />
</button>;